import { render, staticRenderFns } from "./zCpfCnpj.vue?vue&type=template&id=b6f2e398&scoped=true&"
import script from "./zCpfCnpj.vue?vue&type=script&lang=js&"
export * from "./zCpfCnpj.vue?vue&type=script&lang=js&"
import style0 from "./zCpfCnpj.vue?vue&type=style&index=0&id=b6f2e398&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6f2e398",
  null
  
)

export default component.exports